import { render, staticRenderFns } from "./mRP.vue?vue&type=template&id=5d568da4&scoped=true"
import script from "./mRP.vue?vue&type=script&lang=js"
export * from "./mRP.vue?vue&type=script&lang=js"
import style0 from "./mRP.vue?vue&type=style&index=0&id=5d568da4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d568da4",
  null
  
)

export default component.exports